import { User, PaginatedResponse, PaginationParams } from '@console/utils';
import { apiClient } from './client';

export interface CreateUserDto {
  email: string;
  name: string;
  role: 'ADMIN' | 'VIEWER' | 'TIME_TRACKER';
  remoteId?: string;
  isActive?: boolean;
  groupId?: string;
}

export interface UpdateUserDto {
  email?: string;
  name?: string;
  role?: 'ADMIN' | 'VIEWER' | 'TIME_TRACKER';
  remoteId?: string;
  isActive?: boolean;
  groupId?: string;
}

export const usersApi = {
  getAll: async (params?: PaginationParams): Promise<PaginatedResponse<User>> => {
    const queryString = params
      ? `?${new URLSearchParams({
          ...(params.page && { page: params.page.toString() }),
          ...(params.limit && { limit: params.limit.toString() }),
        }).toString()}`
      : '';
    const response = await apiClient.get(`/users${queryString}`);
    return response.data;
  },

  getById: async (id: string): Promise<User> => {
    const response = await apiClient.get(`/users/${id}`);
    return response.data;
  },

  create: async (data: CreateUserDto): Promise<User> => {
    const response = await apiClient.post('/users', data);
    return response.data;
  },

  update: async (id: string, data: UpdateUserDto): Promise<User> => {
    const response = await apiClient.patch(`/users/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/users/${id}`);
  },
};
